module.exports = __webpack_public_path__ + "assets/img/icon-badge-b3e96654.png";